import { render, staticRenderFns } from "./MainFormDialog.vue?vue&type=template&id=f3a6ff1e"
import script from "./MainFormDialog.vue?vue&type=script&lang=js"
export * from "./MainFormDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports